import React, { FC } from "react";
import { ChildComponentProps } from "google-map-react";

import { CameraInfo, ICameraInfo } from "./CameraInfo";

interface CameraProps extends ChildComponentProps {
  color: string;
  zoom: number;
  cameraInfo: ICameraInfo;
  index: number;
  rotate?: string;
}

export const Camera: FC<CameraProps> = ({
  color,
  zoom,
  $hover,
  cameraInfo,
  index,
  rotate = "0deg",
}) => {
  return (
    <div
      style={{
        transform: `translate(-50%, -50%)`,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {$hover && <CameraInfo info={cameraInfo} />}

      <svg
        width="189"
        height="135"
        viewBox="0 0 189 135"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transform: `scale(${zoom / 28}) rotate(${rotate})` }}
      >
        <g clipPath="url(#clip0)">
          <path
            d="M95.3257 116.535L7.7852 55.0451C14.9142 44.8968 23.7542 36.067 33.9107 28.9491C81.9727 -4.74265 149.22 7.06568 182.912 55.1197L95.3257 116.535Z"
            fill={`url(#paint${index}_linear`}
          />
          <path
            d="M182.911 55.1197L95.3255 116.535L7.7852 55.0451"
            stroke="white"
            strokeWidth="4"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <path
            d="M182.911 55.1197L95.3255 116.535L7.7852 55.0451"
            stroke="#231F20"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <g filter="url(#filter0_d)">
            <path
              d="M105.025 83.9738L104.327 78.9231C104.327 78.9231 101.901 73.7921 95.3018 73.7966C88.7027 73.8009 86.2841 78.9352 86.2841 78.9352L85.589 83.9868"
              fill="white"
            />
            <path
              d="M105.025 83.9738L104.327 78.9231C104.327 78.9231 101.901 73.7921 95.3018 73.7966C88.7027 73.8009 86.2841 78.9352 86.2841 78.9352L85.589 83.9868"
              stroke="#231F20"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M95.3223 116.465L123.451 116.446C123.718 116.446 123.973 116.34 124.162 116.151C124.35 115.963 124.455 115.707 124.455 115.441L124.453 111.394L125.335 111.394C125.743 111.393 126.133 111.23 126.421 110.942C126.709 110.654 126.871 110.263 126.871 109.856C126.87 109.448 126.708 109.058 126.419 108.771C126.131 108.483 125.74 108.322 125.333 108.322L124.554 108.323L123.36 93.6916C123.343 93.497 123.285 93.3081 123.189 93.1381C123.093 92.9679 122.961 92.8207 122.802 92.7062C120.534 91.0783 110.943 84.5183 100.346 82.9938L100.183 84.053L95.295 83.9585L90.407 84.0595L90.2433 83.0005C79.6537 84.5392 70.0628 91.0987 67.7971 92.7431C67.6403 92.8584 67.511 93.0063 67.4166 93.1767C67.3231 93.3469 67.2682 93.5354 67.2547 93.7293L66.0778 108.362L65.094 108.363C64.743 108.362 64.4065 108.501 64.1573 108.748C63.9082 108.994 63.767 109.33 63.7644 109.681L63.7654 110.612C63.7657 110.828 63.8515 111.035 64.0044 111.188C64.1573 111.341 64.3644 111.427 64.58 111.426L66.1905 111.425L66.1937 115.472C66.1938 115.738 66.2993 115.994 66.488 116.182C66.6767 116.37 66.9324 116.476 67.1991 116.476L95.3223 116.457"
              fill="white"
            />
            <path
              d="M95.3223 116.465L123.451 116.446C123.718 116.446 123.973 116.34 124.162 116.151C124.35 115.963 124.455 115.707 124.455 115.441L124.453 111.394L125.335 111.394C125.743 111.393 126.133 111.23 126.421 110.942C126.709 110.654 126.871 110.263 126.871 109.856C126.87 109.448 126.708 109.058 126.419 108.771C126.131 108.483 125.74 108.322 125.333 108.322L124.554 108.323L123.36 93.6916C123.343 93.497 123.285 93.3081 123.189 93.1381C123.093 92.9679 122.961 92.8207 122.802 92.7062C120.534 91.0783 110.943 84.5183 100.346 82.9938L100.183 84.053L95.295 83.9585L90.407 84.0595L90.2433 83.0005C79.6537 84.5392 70.0628 91.0987 67.7971 92.7431C67.6403 92.8584 67.511 93.0063 67.4166 93.1767C67.3231 93.3469 67.2682 93.5354 67.2547 93.7293L66.0778 108.362L65.094 108.363C64.743 108.362 64.4065 108.501 64.1573 108.748C63.9082 108.994 63.767 109.33 63.7644 109.681L63.7654 110.612C63.7657 110.828 63.8515 111.035 64.0044 111.188C64.1573 111.341 64.3644 111.427 64.58 111.426L66.1905 111.425L66.1937 115.472C66.1938 115.738 66.2993 115.994 66.488 116.182C66.6767 116.37 66.9324 116.476 67.1991 116.476L95.3223 116.457"
              stroke="#231F20"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M86.6104 83.7146L86.6104 84.6326C86.6104 84.6326 67.6803 93.5744 67.1167 95.9157"
              stroke="#231F20"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M124.554 108.312L95.3167 108.332L66.08 108.351"
              stroke="#231F20"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M124.556 111.386L95.3189 111.406L66.0821 111.425"
              stroke="#231F20"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M103.99 83.7029L103.991 84.6208C103.991 84.6208 122.931 93.5371 123.497 95.8777"
              stroke="#231F20"
              strokeWidth="1.44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M95.3155 106.352L121.114 106.275C121.236 106.274 121.356 106.249 121.467 106.2C121.579 106.151 121.679 106.079 121.761 105.989C121.843 105.9 121.906 105.794 121.946 105.679C121.985 105.564 122.001 105.442 121.991 105.321L121.243 96.0801C121.232 95.9263 121.18 95.778 121.093 95.6504C121.006 95.5228 120.887 95.4201 120.748 95.3527L101.393 86.0319C101.356 86.0133 101.318 85.998 101.279 85.9859C100.915 85.872 98.9348 85.3085 95.3041 85.311C91.6732 85.3134 89.6884 85.8796 89.33 85.9939C89.2911 86.0069 89.253 86.0224 89.216 86.0402L69.8679 95.376C69.7277 95.4446 69.6072 95.549 69.5197 95.6789C69.4332 95.8085 69.3814 95.9591 69.3711 96.1151L68.6495 105.349C68.6406 105.47 68.6568 105.592 68.6965 105.707C68.7363 105.822 68.7994 105.928 68.8824 106.017C68.9653 106.106 69.065 106.178 69.177 106.227C69.288 106.276 69.4082 106.301 69.5306 106.301L95.3155 106.352Z"
              stroke="#231F20"
              strokeMiterlimit="10"
            />
            <mask
              id="mask0"
              mask-type="alpha"
              maskUnits="userSpaceOnUse"
              x="67"
              y="83"
              width="56"
              height="28"
            >
              <path
                d="M95.3155 106.352L121.114 106.275C121.236 106.274 121.356 106.249 121.467 106.2C121.579 106.151 121.679 106.079 121.761 105.989C121.843 105.9 121.906 105.794 121.946 105.679C121.985 105.564 122.001 105.442 121.991 105.321L121.243 96.0801C121.232 95.9263 121.18 95.778 121.093 95.6504C121.006 95.5228 120.887 95.4201 120.748 95.3527L101.393 86.0319C101.356 86.0133 101.318 85.998 101.279 85.9859C100.915 85.872 98.9349 85.3085 95.3041 85.311C91.6732 85.3134 89.6884 85.8796 89.33 85.9939C89.2911 86.0069 89.253 86.0224 89.216 86.0402L69.8679 95.376C69.7277 95.4446 69.6072 95.549 69.5197 95.6789C69.4332 95.8085 69.3814 95.9591 69.3711 96.1151L68.6495 105.349C68.6406 105.47 68.6568 105.592 68.6965 105.707C68.7363 105.822 68.7994 105.928 68.8824 106.017C68.9653 106.106 69.065 106.178 69.177 106.227C69.288 106.276 69.4082 106.301 69.5306 106.301L95.3155 106.352Z"
                fill="#C4C4C4"
              />
            </mask>
            <g mask="url(#mask0)">
              <path
                d="M71.3421 82.9428L71.3597 109.399"
                stroke="#231F20"
                strokeWidth="1.44"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M75.3342 82.9401L75.3518 109.396"
                stroke="#231F20"
                strokeWidth="1.44"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M79.3294 82.9375L79.3469 109.393"
                stroke="#231F20"
                strokeWidth="1.44"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M83.3214 82.9348L83.339 109.391"
                stroke="#231F20"
                strokeWidth="1.44"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M87.3135 82.932L87.3311 109.388"
                stroke="#231F20"
                strokeWidth="1.44"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M91.3079 82.9295L91.3257 109.385"
                stroke="#231F20"
                strokeWidth="1.44"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M95.2999 82.9267L95.3177 109.383"
                stroke="#231F20"
                strokeWidth="1.44"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M99.2918 82.924L99.3095 109.38"
                stroke="#231F20"
                strokeWidth="1.44"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M103.284 82.9214L103.302 109.377"
                stroke="#231F20"
                strokeWidth="1.44"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M107.279 82.9187L107.296 109.375"
                stroke="#231F20"
                strokeWidth="1.44"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M111.271 82.916L111.288 109.372"
                stroke="#231F20"
                strokeWidth="1.44"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M115.263 82.9133L115.28 109.369"
                stroke="#231F20"
                strokeWidth="1.44"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M119.255 82.9107L119.273 109.367"
                stroke="#231F20"
                strokeWidth="1.44"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M95.2938 73.7966C101.893 73.7921 104.319 78.9231 104.319 78.9231L105.017 83.9738C113.652 86.3605 120.876 91.2954 122.803 92.6954C122.961 92.8099 123.093 92.9572 123.189 93.1272C123.285 93.2973 123.343 93.4861 123.36 93.6807L124.554 108.312L125.333 108.311C125.74 108.311 126.131 108.473 126.419 108.76C126.708 109.047 126.87 109.438 126.871 109.845C126.871 110.252 126.709 110.643 126.421 110.931C126.133 111.219 125.743 111.382 125.335 111.383L124.453 111.383L124.455 115.43C124.456 115.696 124.35 115.952 124.162 116.14C123.973 116.329 123.718 116.435 123.451 116.435L97.4977 116.453L97.498 116.909L93.153 116.912L93.1527 116.466L67.1937 116.484C66.927 116.484 66.6713 116.378 66.4826 116.19C66.2939 116.002 66.1884 115.746 66.1884 115.48L66.1851 111.434L64.5806 111.435C64.364 111.435 64.157 111.349 64.004 111.196C63.8511 111.044 63.7653 110.837 63.7651 110.62L63.765 109.689C63.7649 109.514 63.799 109.341 63.866 109.18C63.9321 109.019 64.0303 108.872 64.1534 108.749C64.2775 108.625 64.4245 108.527 64.585 108.461C64.7464 108.394 64.9193 108.36 65.0948 108.36L66.0776 108.359L67.2545 93.7266C67.269 93.5331 67.325 93.3448 67.4185 93.1747C67.5119 93.0046 67.6412 92.8566 67.7969 92.7405C69.7243 91.3433 76.9414 86.3933 85.5705 83.9949L86.284 78.9352C86.284 78.9352 88.7029 73.8009 95.3019 73.7965L95.2938 73.7966ZM95.3012 72.7102C88.0966 72.7151 85.4119 78.2352 85.3004 78.4715L85.2304 78.6209L85.2088 78.7865L84.6109 83.1321C76.1374 85.6389 69.1506 90.4122 67.1714 91.8529C66.8861 92.0598 66.6494 92.3259 66.4761 92.6331C66.3037 92.9403 66.199 93.2811 66.1703 93.6324L65.0775 107.266C64.4401 107.271 63.8307 107.528 63.3814 107.98C62.9322 108.433 62.6794 109.044 62.6784 109.682L62.6794 110.613C62.6793 111.117 62.8803 111.601 63.2371 111.957C63.5939 112.313 64.0773 112.513 64.5817 112.513L65.1001 112.512L65.1017 115.472C65.1034 116.027 65.324 116.558 65.7166 116.95C66.1081 117.342 66.6402 117.562 67.1948 117.562L92.0589 117.545L92.0593 118.002L98.5769 117.997L98.5766 117.549L123.444 117.532C123.998 117.531 124.529 117.309 124.92 116.917C125.312 116.525 125.532 115.994 125.534 115.44L125.532 112.461C126.186 112.407 126.797 112.109 127.243 111.627C127.689 111.144 127.938 110.511 127.94 109.854C127.942 109.197 127.697 108.563 127.254 108.078C126.811 107.592 126.202 107.291 125.547 107.233L124.435 93.5931C124.406 93.242 124.301 92.9012 124.128 92.5944C123.955 92.2874 123.718 92.0216 123.432 91.815C121.451 90.3825 114.466 85.6131 105.989 83.1231L105.386 78.7784L105.364 78.6128L105.291 78.4635C105.182 78.2273 102.49 72.7109 95.2849 72.7157L95.3012 72.7102Z"
                fill="#231F20"
              />
            </g>
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d"
            x="46.0703"
            y="61.3185"
            width="97.0522"
            height="79.3455"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="7.5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
          <linearGradient
            id={`paint${index}_linear`}
            x1="79.4086"
            y1="-26.7802"
            x2="91.6169"
            y2="117.422"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.3" stopColor={color} stopOpacity="0" />
            <stop offset="1" stopColor={color} />
          </linearGradient>
          <clipPath id="clip0">
            <rect
              width="185"
              height="129"
              fill="white"
              transform="translate(188.974 129.072) rotate(178.206)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
